import { render, staticRenderFns } from "./localSend.vue?vue&type=template&id=d936b81a&scoped=true&"
import script from "./localSend.vue?vue&type=script&lang=js&"
export * from "./localSend.vue?vue&type=script&lang=js&"
import style0 from "./localSend.vue?vue&type=style&index=0&id=d936b81a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d936b81a",
  null
  
)

export default component.exports